import { apiEndpoints } from './common'

import { makeRequestUrl } from '../app/helpers'
import { get, post, remove } from '../request'

// Centre Audit > Scorecard. Facts only — Keka days, moments per day and the
// Classroom Observations per teacher; the page turns them into /5 scores.
// Returns { weeks: [Monday ISO...], start, end, keka_latest, total,
// teachers: [{ no, name, job, dept, cc, linked, days: { iso: { s, st, in,
// late } }, moments: { iso: n }, observations: [{ d, kind, title, by,
// env: [{ label, a }], fac }] }] }. offset/limit page the teachers (same order
// every call); total is how many there are in all.
// No limit = every teacher. The limit always goes in the URL: request.js adds
// limit=25 to any GET whose URL has none, which cut the page to the first 25
// teachers (23 Oct).
const EVERY_TEACHER = 1000

export const getTeacherScorecard = async ({
  end,
  weeks,
  offset,
  limit
} = {}) => {
  const params = { limit: limit || EVERY_TEACHER }
  if (end) params.end = end
  if (weeks) params.weeks = weeks
  if (offset) params.offset = offset
  const response = await get(
    makeRequestUrl(apiEndpoints.teacherScorecard, params)
  )
  return response.data
}

// One week's box in the teacher pop-up (28 Oct): kind = evals | plans,
// week = its Monday. Returns { rows: [{ name, class, done, status }] }.
export const getScorecardWeekDetail = async ({ no, kind, week }) => {
  const response = await get(
    makeRequestUrl(`${apiEndpoints.teacherScorecard}/week`, {
      no,
      kind,
      week,
      limit: EVERY_TEACHER
    })
  )
  return response.data
}

// Actions tab (27 Oct): { week_start, list_made, freeze_weeks, actions }.
// The first visit of a week sends the rules' list (made once, then fixed)
// and the results of ticks whose 2-week freeze is over.
const ACTIONS_URL = () => `${apiEndpoints.teacherScorecard}/actions`

export const getScorecardActions = async () => {
  const response = await get(
    makeRequestUrl(ACTIONS_URL(), { limit: EVERY_TEACHER })
  )
  return response.data
}

export const makeScorecardActionWeek = async ({ items, results }) => {
  const response = await post(`${ACTIONS_URL()}/week`, { items, results })
  return response.data
}

// Log action: how = what the CD did ('Not done yet' keeps it open), note =
// one line about it.
export const markScorecardAction = async (id, { how, note } = {}) => {
  const response = await post(`${ACTIONS_URL()}/${id}/done`, { how, note })
  return response.data
}

export const unmarkScorecardAction = async (id) => {
  const response = await remove(`${ACTIONS_URL()}/${id}/done`)
  return response.data
}
